export default __webpack_public_path__ + "static/media/7 - Кофейня.026a532d.jpg";